import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react/components/shared/Icon";
import { useThemeContext } from "@circle-react/providers";

export interface SummarizeButtonProps {
  isOpen: boolean;
}

export const SummarizeButton = ({ isOpen }: SummarizeButtonProps) => {
  const { isDarkAppearance } = useThemeContext();

  return (
    <button
      type="button"
      aria-label={t("ai_spaces_summaries.summarize")}
      className="text-xs-plus bg-overlay-dark group flex items-center justify-center rounded-full p-[1px] transition-colors hover:bg-gradient-to-bl hover:from-[#d4dbff] hover:to-[#c6b3fa] dark:hover:bg-gradient-to-br dark:hover:from-[#516DF1] dark:hover:to-[#6C47D2]"
    >
      <div
        className={classNames(
          "bg-primary text-darkest flex items-center justify-center rounded-full px-4 py-2.5 transition-colors group-hover:bg-gradient-to-bl group-hover:from-white group-hover:to-violet-50 group-hover:dark:bg-gradient-to-bl group-hover:dark:from-[#516DF1] group-hover:dark:to-[#6C47D2]",
          {
            "bg-gradient-to-bl from-white to-violet-50 dark:bg-gradient-to-bl dark:from-[#516DF1] dark:to-[#6C47D2]":
              isOpen,
          },
        )}
      >
        <div
          className={classNames(
            "text-dark w-0 overflow-hidden text-sm font-medium leading-tight transition-all duration-300 ease-out group-hover:w-auto group-hover:pr-1.5",
            {
              "w-auto pr-1.5": isOpen,
            },
          )}
        >
          <span
            className={classNames(
              "opacity-0 transition-opacity delay-0 duration-0 ease-out group-hover:opacity-100 group-hover:delay-200 group-hover:duration-300",
              {
                "opacity-100": isOpen,
              },
            )}
          >
            {t("ai_spaces_summaries.summarize")}
          </span>
        </div>
        <Icon
          type={isDarkAppearance ? "20-stardust" : "20-stardust-gradient"}
          size={20}
          className="group-hover:animate-spin-pause-reverse"
        />
      </div>
    </button>
  );
};
